import { FlexBox } from '@dixa/lib-shared-habla';
import { ReactNode } from 'react';

type DeliveryStatusMessageProps = {
  icon: ReactNode;
  label: ReactNode;
  contactPoint?: string;
};

export const DeliveryStatusMessage = ({
  icon,
  label,
  contactPoint,
}: DeliveryStatusMessageProps): JSX.Element => {
  return (
    <FlexBox gap="400" alignItems="center" flexDirection="column">
      <FlexBox gap="200" alignItems="center">
        {icon}
        {label}
      </FlexBox>

      {contactPoint && <FlexBox width="100%">{contactPoint}</FlexBox>}
    </FlexBox>
  );
};
